import React from "react";
import { useTranslation } from "react-i18next";

const SteppedProgressBar = ({
  progress = 0,
  message,
  headingKey,
  statusMessages,
  finalMessage,
  steps = 3,
}) => {
  const { t } = useTranslation();

  return (
    <div className="w-full">
      <div className="flex items-center justify-between my-3">
        <h3 className="text-[#fff] font-[600] text-[20px]">{t(headingKey)}</h3>
      </div>

      <div className="flex items-center justify-between my-3">
        <p className="text-[#fff] text-sm">
          {progress === 100 ? t(finalMessage) : t(statusMessages?.[message ?? 25])}
        </p>
      </div>

      <div className="flex w-full h-[22px] gap-[2px] overflow-hidden bg-white p-1 rounded-[9px]">
        {[...Array(steps)].map((_, i) => {
          const stepNumber = i + 1;
          let isFilled = false;

          if (progress === 100) isFilled = true;
          else if (message == 75) isFilled = stepNumber <= 2;
          else if (message == 50) isFilled = stepNumber <= 1;

          return (
            <div
              key={i}
              className="h-full rounded-[9px] relative flex-1"
              style={{ backgroundColor: isFilled ? "transparent" : "#E6E6E6" }}
            >
              {isFilled && (
                <div
                  className="absolute top-0 left-0 h-full rounded-[9px] w-full"
                  style={{ background: "linear-gradient(180deg, #0771EF 0%, #15AAFC 100%)" }}
                />
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default SteppedProgressBar;